import {Button, Stack, Typography} from '@mui/material';
import {IconIllustration, Modal} from 'presentation/components';
import {HomeEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {ErrorOnCreateRequestModalProps} from './types';

const {title, subtitle, description, tryAgainBtn, backAction} =
	translations['pt-br'].privateFlow.refund.receiptRegistrationPage.errorModal;

const ErrorOnCreateRequestModal = ({open, setOpen, onConfirm}: ErrorOnCreateRequestModalProps) => {
	const navigate = useNavigate();
	function handleNavigateToInitial() {
		navigate(HomeEnum.HOME_PAGE);
	}

	return (
		<Modal.Root
			open={open}
			onClose={() => setOpen(false)}
			slotProps={{paper: {style: {maxWidth: 420}}}}>
			<Modal.Header onClose={() => setOpen(false)} title={title} />

			<Modal.Content>
				<Stack spacing={2} alignItems="center">
					<IconIllustration variant="info" />
					<Typography variant="h6" textAlign="center">
						{subtitle}
					</Typography>
					<Typography textAlign="center" variant="body1">
						{description}
					</Typography>
				</Stack>
			</Modal.Content>

			<Modal.Footer>
				<Stack width="100%" spacing={1}>
					<Button
						fullWidth
						size="large"
						variant="outlined"
						onClick={handleNavigateToInitial}>
						{backAction}
					</Button>
					<Button onClick={onConfirm} fullWidth size="large" variant="contained">
						{tryAgainBtn}
					</Button>
				</Stack>
			</Modal.Footer>
		</Modal.Root>
	);
};

export {ErrorOnCreateRequestModal};
